import { useEffect, useMemo, useState } from "react";

import { IKeyStringAndValue } from "../types/Types";

const useComparePreviusValuesWithCurrent = (
  filteredData: Array<IKeyStringAndValue>,
  filterOptions: IKeyStringAndValue,
  setInputValue: React.Dispatch<React.SetStateAction<string>>
) => {
  //Saves previous Make value
  const [prevFirstValue, setPrevFirstValue] = useState<string>("");
  //Saves Make as ref for snapshot of filteredData
  const [firstFilterValue, setFirstFilterValue] = useState<string>();
  //Gets current Make value
  const currFirstValue = useMemo(() => {
    return (Object.entries(filterOptions) as [[string, string]]).reduce<string>(
      (acc, currArr) => {
        if (currArr[0] === "make" && currArr[1] !== "default") acc = currArr[1];
        return acc;
      },
      ""
    );
  }, [filterOptions]); //Snapshot of filteredData with make only filter on
  //to get the right amount of options //Ex. if you choose one brand only models of that brand should show in select
  const filteredDataSnapshot = useMemo(() => {
    return filteredData.filter(
      (car: IKeyStringAndValue) =>
        car.make === firstFilterValue ||
        firstFilterValue === "default" ||
        Object.keys(filterOptions).length === 0
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevFirstValue, currFirstValue]);
  useEffect(() => {
    if (prevFirstValue !== currFirstValue) {
      setInputValue("");
      setFirstFilterValue(currFirstValue ? currFirstValue : "default");
    }
    setPrevFirstValue(currFirstValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData]);
  return { filteredDataSnapshot, setFirstFilterValue };
};
export default useComparePreviusValuesWithCurrent;
